export const filtroDependentesSemValor = (dependentes) => {
    if (dependentes.length > 0) {
        return dependentes.filter(
            (dependente) =>
                dependente['CategoriaParentesco.Categoria'].trim() === 'ZELO'
        );
    }
};

export const filtroDependentesTipoConjugeSemValor = (dependentes) => {
    if (dependentes.length > 0) {
        const dependentesSemMensalidade = filtroDependentesSemValor(dependentes);
        return dependentesSemMensalidade.filter(
            (dependente) => dependente.Parentesco === 'ESPOSO(A)'
        );
    }
};

export const filtroDependentesDiferenteConjuge = (dependentes) => {
    if (dependentes.length > 0) {
        const dependentesSemMensalidade = filtroDependentesSemValor(dependentes);
        return dependentesSemMensalidade.filter(
            (dependente) => dependente.Parentesco !== 'ESPOSO(A)'
        );
    }
};

export const filtroDependentesDeOutrosTipos = (dependentes) => {
    if (dependentes.length > 0) {
        return dependentes.filter(
            (dependente) =>
                dependente['CategoriaParentesco.Categoria'].substr(0, 2) !== 'ZU' &&
                dependente['CategoriaParentesco.Valor'] !== 0
        );
    }
};
